export enum WatchListTypeEnum {
  None,
  MostActive,
  Trader2B,
}